module.exports = __webpack_public_path__ + "img/clear_creek.944a3fbd.jpg";